// eslint-disable-next-line no-restricted-imports
import {useInViewEffect} from '@aboutyou/ui-components';
import {trackShopFeature} from '@aboutyou/legacy-tracking-sdk';
import {useCallback} from 'react';
import {IntersectionOptions} from 'react-intersection-observer';
import {useTracking} from '../utils/utils';

interface TrackFeatureProps {
  label?: string;
  value?: string | number;
  name?: string;
}

export const useTrackFeatureInViewImpression = <T extends HTMLElement>(
  {label, value, name}: TrackFeatureProps,
  options?: IntersectionOptions,
) => {
  const {TrackingClient} = useTracking();

  const {ref} = useInViewEffect<T>(
    useCallback(
      inView => {
        inView &&
          TrackingClient.track(
            trackShopFeature({
              feature: {
                type: 'impression',
                label: label ?? null,
                value: value ?? null,
                name: name ?? label,
              },
            }),
          );
      },
      [TrackingClient, label, name, value],
    ),
    options ?? {triggerOnce: true, threshold: 0.2},
  );

  return {ref};
};
